var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceScanCircleSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 174.056,
    height: 174.056,
    viewBox: "0 0 174.056 174.056",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "face-scan-circle-svgrepo-com",
    transform: "translate(-1.45 -1.45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M30.5,21.374c0,6.833-3.693,12.373-8.249,12.373S14,28.207,14,21.374,17.693,9,22.249,9,30.5,14.54,30.5,21.374Z",
    transform: "translate(90.975 54.731)",
    fill: "#9e9e9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M24.5,21.374c0,6.833-3.693,12.373-8.249,12.373S8,28.207,8,21.374,11.693,9,16.249,9,24.5,14.54,24.5,21.374Z",
    transform: "translate(47.481 54.731)",
    fill: "#9e9e9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M98.912,6.408a6.187,6.187,0,0,1,7.294-4.832,88.775,88.775,0,0,1,69.176,69.174,6.187,6.187,0,0,1-12.127,2.461A76.4,76.4,0,0,0,103.744,13.7,6.187,6.187,0,0,1,98.912,6.408Zm-20.868,0A6.187,6.187,0,0,1,73.211,13.7,76.4,76.4,0,0,0,13.7,73.211,6.187,6.187,0,0,1,1.575,70.75,88.774,88.774,0,0,1,70.75,1.575,6.187,6.187,0,0,1,78.044,6.408ZM6.408,98.913a6.187,6.187,0,0,1,7.294,4.832,76.4,76.4,0,0,0,59.51,59.51,6.187,6.187,0,0,1-2.461,12.126A88.774,88.774,0,0,1,1.576,106.207,6.187,6.187,0,0,1,6.408,98.913Zm164.14,0a6.187,6.187,0,0,1,4.833,7.294,88.775,88.775,0,0,1-69.176,69.174,6.187,6.187,0,0,1-2.461-12.126,76.4,76.4,0,0,0,59.51-59.51A6.187,6.187,0,0,1,170.548,98.913ZM58.76,117.79a6.186,6.186,0,0,1,8.654-1.286,35.059,35.059,0,0,0,42.126,0,6.186,6.186,0,1,1,7.368,9.94,47.43,47.43,0,0,1-56.862,0A6.186,6.186,0,0,1,58.76,117.79Z",
    transform: "translate(0 0)",
    fill: "#9e9e9e",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceScanCircleSvgrepoCom);
export default __webpack_public_path__ + "static/media/face-scan-circle-svgrepo-com.8ec9232d0abd748ec41337da3e90f2e5.svg";
export { ForwardRef as ReactComponent };